import useSWR from 'swr'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { buildQuery } from '../../Service/os'
import {
  OsAnalytics,
  OsAnalyticsFilters,
  OsCharts,
  OsConfig,
  OsDetail,
  OsKpis,
  OsListFilters,
  OsListRow,
  OsPracaOption,
  OsTecnicoDropdown,
} from '../../types/os'

const BASE = 'producer/analytics'

export const useOsList = (filters: OsListFilters) => {
  const url = `${BASE}/getOsList?${buildQuery(filters as Record<string, any>)}`
  const { data, error, isLoading, mutate } = useSWR(url, () =>
    APIDecoratorWithBaseURI().get(url),
  )
  const body = data?.data
  return {
    rows: (body?.data ?? []) as OsListRow[],
    kpis: body?.kpis as OsKpis | undefined,
    charts: body?.charts as OsCharts | undefined,
    lastPage: body?.last_page as boolean | undefined,
    page: body?.page as number | undefined,
    pracas: (body?.pracas ?? []) as OsPracaOption[],
    isLoading,
    isError: error,
    // Sessão vencida no backend (rede de segurança do OP-3462; quem navega é a página)
    isUnauthorized: (error as any)?.response?.status === 401,
    mutate,
  }
}

export const useOsAnalytics = (filters: OsAnalyticsFilters) => {
  const url = `${BASE}/getOsAnalytics?${buildQuery(filters as Record<string, any>)}`
  const { data, error, isLoading, mutate } = useSWR(url, () =>
    APIDecoratorWithBaseURI().get(url),
  )
  return {
    analytics: data?.data?.body as OsAnalytics | undefined,
    pracas: (data?.data?.pracas ?? []) as OsPracaOption[],
    isLoading,
    isError: error,
    mutate,
  }
}

export const useOsDetail = (id?: number) => {
  const url = id ? `${BASE}/getOsDetail?id=${id}` : null
  // Sem revalidação automática: a tela de edição não pode recarregar sozinha
  // (apagaria o que o usuário está preenchendo). Atualiza só via mutate().
  const { data, error, isLoading, mutate } = useSWR(
    url,
    () => APIDecoratorWithBaseURI().get(url as string),
    { revalidateOnFocus: false, refreshInterval: 0 },
  )
  return {
    detail: data?.data?.data as OsDetail | undefined,
    isLoading,
    isError: error,
    isUnauthorized: (error as any)?.response?.status === 401,
    mutate,
  }
}

export const useOsConfig = () => {
  const url = `${BASE}/getOsConfig`
  const { data, error, isLoading, mutate } = useSWR(url, () =>
    APIDecoratorWithBaseURI().get(url),
  )
  return {
    config: data?.data?.data as OsConfig | null | undefined,
    isLoading,
    isError: error,
    mutate,
  }
}

export const useOsTecnicos = (search?: string) => {
  const url = `${BASE}/getOsTecnicos${search ? `?search=${encodeURIComponent(search)}` : ''}`
  const { data, error, isLoading, mutate } = useSWR(url, () =>
    APIDecoratorWithBaseURI().get(url),
  )
  return {
    tecnicos: (data?.data?.data ?? []) as OsTecnicoDropdown[],
    isLoading,
    isError: error,
    mutate,
  }
}
